module.exports = __webpack_public_path__ + "static/media/portrait.c9d81a5d.png";